import Vue from 'vue';
import I18n from '@/helpers/I18n';
import messages from '@/locales/messages';

Vue.use(I18n, {translations: messages});
Vue.Config('i18n').then((config: any) =>
{
    if (config)
    {
        Vue.i18n.setLanguages(config.languages);
        Vue.i18n.detectLocale(config.locale);
    }
});
